import React, { Fragment, useEffect } from "react"

const SingleQuater = ({ setSelectedOptions, Selected, setSelected }) => {
    const getCurrentQuarter = () => {
        const month = new Date().getMonth() + 1; // getMonth() returns month from 0-11
        if (month >= 4 && month <= 6) return { value: '4', name: 'Quarter 1 (Apr- Jun)' };
        if (month >= 7 && month <= 9) return { value: '7', name: 'Quarter 2 (Jul- Sep)' };
        if (month >= 10 && month <= 12) return { value: '10', name: 'Quarter 3 (Oct- Dec)' };
        return { value: '1', name: 'Quarter 4 (Jan- Mar)' };
    }

    useEffect(() => {
        const storedQuarter = sessionStorage.getItem("singleQuarter")
        if (storedQuarter) {
            const parsedQuarter = JSON.parse(storedQuarter)
            setSelected(parsedQuarter)
            setSelectedOptions(parsedQuarter)
            sessionStorage.setItem("CurrentMonthCP", parsedQuarter.value)
        } else {
            const currentQuarter = getCurrentQuarter();
            sessionStorage.setItem("singleQuarter", JSON.stringify(currentQuarter));
            sessionStorage.setItem("CurrentMonthCP", currentQuarter.value);
            setSelected(currentQuarter);
            setSelectedOptions(currentQuarter);
        }
    }, [setSelected, setSelectedOptions])

    const handleChange = (e) => {
        const selectedOption = {
            value: e.target.value,
            name: e.target.options[e.target.selectedIndex].text
        }
        sessionStorage.setItem("singleQuarter", JSON.stringify(selectedOption))
        sessionStorage.setItem("CurrentMonthCP", selectedOption.value)
        setSelected(selectedOption)
        setSelectedOptions(selectedOption)
    }
    
    return (
        <Fragment>

            <select
                className="form-control form-select"
                name="Quarter"
                value={Selected?.value || "none"}
                onChange={(e) => handleChange(e)}
            >
                <option value="none" hidden selected disabled>Select</option>

                <option value="4" > Quarter 1 (Apr- Jun)</option>
                <option value="7" > Quarter 2 (Jul- Sep)</option>
                <option value="10" > Quarter 3 (Oct- Dec)</option>
                <option value="1" > Quarter 4 (Jan- Mar)</option>

            </select>
        </Fragment>
    )
}
export default SingleQuater